<template>
  <div class="sidebar">
    <!-- <div class="sidebar-widget style4">
      <h4>Search Here</h4>
      <div class="search-box">
        <div class="form-group">
          <input type="search" placeholder="Search" />
          <button type="submit">
            <i class="ri-search-2-line"></i>
          </button>
        </div>
      </div>
    </div> -->

    <div class="sidebar-widget categories">
      <h4>Specialitati</h4>
      <div class="category-box">
        <ul class="list-style">
          <li :class="{ active: isActive('/specialitati/cardiologie') }">
            <router-link to="/specialitati/cardiologie#specialitati">
              Cardiologie
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>
          <!-- 
          <li :class="{ active: isActive('/specialitati/diabet_si_nutritie') }">
            <router-link to="/specialitati/diabet_si_nutritie#specialitati">
              Diabet și nutriție
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li> -->
          <li :class="{ active: isActive('/specialitati/diabet_nutritie_si_boli_metabolice') }">
            <router-link to="/specialitati/diabet_nutritie_si_boli_metabolice#specialitati">
              Diabet, Nutriție și Boli Metabolice
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>
          <li :class="{ active: isActive('/specialitati/endocrinologie') }">
            <router-link to="/specialitati/endocrinologie#specialitati">
              Endocrinologie
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li> 
          <li :class="{ active: isActive('/specialitati/neurologie') }">
            <router-link to="/specialitati/neurologie#specialitati">
              Neurologie
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li> 
          <li :class="{ active: isActive('/specialitati/psihiatrie') }">
            <router-link to="/specialitati/psihiatrie#specialitati">
              Psihiatrie
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li> 
          <li :class="{ active: isActive('/specialitati/reumatologie') }">
            <router-link to="/specialitati/reumatologie#specialitati">
              Reumatologie
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li> 
          <li :class="{ active: isActive('/specialitati/psihologie') }">
            <router-link to="/specialitati/psihologie#specialitati">
              Psihologie
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>
        </ul>

      </div>
    </div>

    <!-- <div class="sidebar-widget">
      <h4>Business Hours</h4>
      <div class="schedule-widget">
        <ul class="list-style">
          <li>
            <h6>Mon-Thurs</h6>
            <p>8:00 AM - 5:00 PM</p>
          </li>
          <li>
            <h6>Fri-Sat</h6>
            <p>8:00 AM - 3:00 PM</p>
          </li>
          <li>
            <h6>Sun</h6>
            <p>Closed</p>
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "SideBar",

  methods: {
    isActive(path) {
      return this.$route.path === path;
    }
  }
};
</script>